import React from 'react';

import { StyledButton } from './zoom-button.styles';

const Button = ({ children, onClick, title }) => {
  return (
    <StyledButton onClick={onClick} title={title}>
      {children}
    </StyledButton>
  );
};

export default Button;
